import classNames from 'clsx';
import curry from 'lodash/curry';
import flow from 'lodash/flow';
import React, { useState } from 'react';
import Icon from '../icon';
import Search from '../search';
import { Styled } from './style';
var isContainKeyword = curry(function (keyword, text) {
    return (text + '').toLowerCase().includes(keyword.toLowerCase());
});
var isItemFieldsMatchSearch = curry(function (keyword, searchText) {
    return searchText.some(function (text) { return isContainKeyword(keyword, text); });
});
var getFilter = function (keyword) { return function (_a) {
    var searchText = _a.keywords;
    return isItemFieldsMatchSearch(keyword, searchText);
}; };
var getChangeEventValue = function (_, _a) {
    var value = _a.value;
    return value;
};
var ScrollableSearch = function (_a) {
    var className = _a.className, items = _a.items, onClickItem = _a.onClickItem, placeHolder = _a.placeHolder, _b = _a.selectedKeys, selectedKeys = _b === void 0 ? [] : _b;
    var _c = useState(''), keyword = _c[0], setKeyword = _c[1];
    return (React.createElement(Styled, { className: classNames('scrollable-search', className) },
        React.createElement(Search, { placeholder: placeHolder || 'Search', onClear: function () { return setKeyword(''); }, value: keyword, onChange: flow(getChangeEventValue, setKeyword), showNoResults: false }),
        React.createElement("div", { className: "list-container" }, items.filter(getFilter(keyword)).map(function (_a) {
            var key = _a.key, label = _a.label, value = _a.value;
            var isSelected = selectedKeys.includes(key);
            return (React.createElement("div", { key: key, className: classNames('list-item', { isSelected: isSelected }), onClick: function () { return onClickItem(value); } },
                label,
                isSelected && React.createElement(Icon, { name: "checked-circle" }),
                isSelected || React.createElement(Icon, { name: "plus-fill" })));
        }))));
};
export default ScrollableSearch;
//# sourceMappingURL=index.js.map